import { IoRefreshOutline } from "react-icons/io5";
import { relativeTime } from "./useStopLossStatus";

const RefreshButton = ({ onRetry, isFetching }) => (
    <button
        type="button"
        className="stoploss-selfservice-card__refresh-btn"
        onClick={onRetry}
        disabled={isFetching}
        title="Refresh status"
    >
        <IoRefreshOutline size={15} className={isFetching ? "spin" : ""} />
        {isFetching ? "Refreshing…" : "Refresh"}
    </button>
);

const StopLossStatusCard = ({
    isError,
    isFetching,
    state,
    failed,
    inCooldown,
    disabled,
    cooldownRemainingMs,
    data,
    onRetry,
    onTriggerClick,
}) => {
    if (isError) {
        return (
            <div className="stoploss-selfservice-card">
                <p className="stoploss-selfservice-card__label">Current status</p>
                <div className="stoploss-selfservice-card__header">
                    <span className="stoploss-selfservice-card__pill UNKNOWN">
                        <span className="stoploss-selfservice-card__pill-dot" />
                        Unknown
                    </span>
                    <span className="stoploss-selfservice-card__detail">
                        Couldn't reach the status check. The report itself may still be fine — try refreshing.
                    </span>
                </div>
                <RefreshButton onRetry={onRetry} isFetching={isFetching} />
            </div>
        );
    }

    let pillClass = "IDLE";
    let pillLabel = "Idle";
    let detail = "No report has been run yet.";

    if (state === "running") {
        pillClass = "RUNNING";
        pillLabel = "Running";
        detail = `Started ${relativeTime(data?.startedAt) || "moments ago"} — usually takes a few minutes. Refresh to check for updates.`;
    } else if (failed) {
        pillClass = "ERROR";
        pillLabel = "Completed with errors";
        detail = `Last run ${relativeTime(data?.lastStoppedAt)} finished with errors — check the ECS logs before running again.`;
    } else if (data?.lastStoppedAt) {
        pillClass = "SUCCESS";
        pillLabel = "Success";
        detail = `Last run completed ${relativeTime(data.lastStoppedAt)}.`;
    }

    return (
        <div className="stoploss-selfservice-card">
            <p className="stoploss-selfservice-card__label">Current status</p>
            <div className="stoploss-selfservice-card__header">
                <span className={`stoploss-selfservice-card__pill ${pillClass}`}>
                    <span className="stoploss-selfservice-card__pill-dot" />
                    {pillLabel}
                </span>
                <span className="stoploss-selfservice-card__detail">{detail}</span>
                <RefreshButton onRetry={onRetry} isFetching={isFetching} />
            </div>

            <div className="stoploss-selfservice-card__action">
                <button
                    className="finance-ops__primary-btn"
                    disabled={disabled}
                    onClick={onTriggerClick}
                >
                    {state === "running" ? "Running…" : "Run report"}
                </button>
                {inCooldown && (
                    <span className="stoploss-selfservice-card__cooldown">
                        You can run it again in ~{Math.ceil(cooldownRemainingMs / 60000)} min
                    </span>
                )}
            </div>
        </div>
    );
};

export default StopLossStatusCard;
